import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var tenantToCustomerCulture = function tenantToCustomerCulture(tenantCulture) {
  var selectedCultureCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : tenantCulture.DefaultCultureCode;
  var customerCulture = tenantCulture.Cultures.find(function (culture) {
    return culture.CultureCode === selectedCultureCode;
  });
  if (!customerCulture && tenantCulture.Cultures.length > 0) {
    var _tenantCulture$Cultur = _slicedToArray(tenantCulture.Cultures, 1);
    customerCulture = _tenantCulture$Cultur[0];
  }
  if (!customerCulture) {
    throw new Error('No Culture found!');
  }
  var financialSet = tenantCulture.FinancialSets.find(function (set) {
    return set.FinancialSetId === tenantCulture.DefaultFinancialSetId;
  });
  if (!financialSet && tenantCulture.FinancialSets.length > 0) {
    var _tenantCulture$Financ = _slicedToArray(tenantCulture.FinancialSets, 1);
    financialSet = _tenantCulture$Financ[0];
  }
  if (!financialSet) {
    throw new Error('No FinancialSet found!');
  }
  return _objectSpread(_objectSpread({}, customerCulture), {}, {
    TimeZone: tenantCulture.TimeZone,
    FinancialSet: financialSet
  });
};